export default "__VITE_ASSET__zuKNiKwP__"